/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortDirection } from './SortDirection';
import {
    SortDirectionFromJSON,
    SortDirectionFromJSONTyped,
    SortDirectionToJSON,
    SortDirectionToJSONTyped,
} from './SortDirection';

/**
 * 
 * @export
 * @interface BusinessUnitTreeNodeExtendedDtoSortingRequestDto
 */
export interface BusinessUnitTreeNodeExtendedDtoSortingRequestDto {
    /**
     * Sortable fields for BusinessUnitTreeNodeExtendedDto: name, code, fullName, description, ownOrderCount, ownOrderAmount, totalOrderCount, totalOrderAmount
     * @type {BusinessUnitTreeNodeExtendedDtoSortingRequestDtoSortByEnum}
     * @memberof BusinessUnitTreeNodeExtendedDtoSortingRequestDto
     */
    sortBy?: BusinessUnitTreeNodeExtendedDtoSortingRequestDtoSortByEnum | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof BusinessUnitTreeNodeExtendedDtoSortingRequestDto
     */
    sortDir?: SortDirection;
}


/**
 * @export
 */
export const BusinessUnitTreeNodeExtendedDtoSortingRequestDtoSortByEnum = {
    name: 'name',
    code: 'code',
    fullName: 'fullName',
    description: 'description',
    ownOrderCount: 'ownOrderCount',
    ownOrderAmount: 'ownOrderAmount',
    totalOrderCount: 'totalOrderCount',
    totalOrderAmount: 'totalOrderAmount'
} as const;
export type BusinessUnitTreeNodeExtendedDtoSortingRequestDtoSortByEnum = typeof BusinessUnitTreeNodeExtendedDtoSortingRequestDtoSortByEnum[keyof typeof BusinessUnitTreeNodeExtendedDtoSortingRequestDtoSortByEnum];


/**
 * Check if a given object implements the BusinessUnitTreeNodeExtendedDtoSortingRequestDto interface.
 */
export function instanceOfBusinessUnitTreeNodeExtendedDtoSortingRequestDto(value: object): value is BusinessUnitTreeNodeExtendedDtoSortingRequestDto {
    return true;
}

export function BusinessUnitTreeNodeExtendedDtoSortingRequestDtoFromJSON(json: any): BusinessUnitTreeNodeExtendedDtoSortingRequestDto {
    return BusinessUnitTreeNodeExtendedDtoSortingRequestDtoFromJSONTyped(json, false);
}

export function BusinessUnitTreeNodeExtendedDtoSortingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnitTreeNodeExtendedDtoSortingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDir': json['sortDir'] == null ? undefined : SortDirectionFromJSON(json['sortDir']),
    };
}

export function BusinessUnitTreeNodeExtendedDtoSortingRequestDtoToJSON(json: any): BusinessUnitTreeNodeExtendedDtoSortingRequestDto {
    return BusinessUnitTreeNodeExtendedDtoSortingRequestDtoToJSONTyped(json, false);
}

export function BusinessUnitTreeNodeExtendedDtoSortingRequestDtoToJSONTyped(value?: BusinessUnitTreeNodeExtendedDtoSortingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sortBy': value['sortBy'],
        'sortDir': SortDirectionToJSON(value['sortDir']),
    };
}

